import React from 'react';
import styles from './Header.module.css';

const BackButton = ({ onClick }) => {
  return (
    <div className={styles.menuItem}>
      <button className={styles.iconButton} onClick={onClick} aria-label="Назад">
        {/* SVG стрелочка назад */}
        <svg className={styles.icon} viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  );
};


export default BackButton;
